import { render, staticRenderFns } from "./water-out.vue?vue&type=template&id=8f2db140&scoped=true"
import script from "./water-out.vue?vue&type=script&lang=js"
export * from "./water-out.vue?vue&type=script&lang=js"
import style0 from "./water-out.vue?vue&type=style&index=0&id=8f2db140&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2db140",
  null
  
)

export default component.exports